import { render, staticRenderFns } from "./SeminarEmailTab.vue?vue&type=template&id=77996cc6&"
import script from "./SeminarEmailTab.vue?vue&type=script&lang=js&"
export * from "./SeminarEmailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports